import {makeAutoObservable, observable, runInAction} from "mobx";
import {injectable, inject} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {IJSONProvider} from "data/providers/json/json.provider";

export interface IPlayerStat {
	playerId: number;
	hitting: {
		avg: number;
		homeRuns: number;
		runs: number;
		rbi: number;
	};
	pitching: {
		strikeOuts: number;
		era: number;
		wins: number;
		walks: number;
	};
}

export interface IPlayerStatsStore {
	get stats(): IPlayerStat[];

	fetchStats(): Promise<void>;

	getStatsByPlayerId: (playerId: number) => IPlayerStat | undefined;
}

@injectable()
export class PlayerStatsStore implements IPlayerStatsStore {
	@observable _stats: IPlayerStat[] = [];

	constructor(@inject(Bindings.JSONProvider) private _jsonProvider: IJSONProvider) {
		makeAutoObservable(this);
	}

	get stats(): IPlayerStat[] {
		return this._stats;
	}

	getStatsByPlayerId = (playerId: number) => {
		return this._stats.find((it) => it.playerId === playerId);
	};

	async fetchStats() {
		const response = await this._jsonProvider.player_stats();

		runInAction(() => {
			this._stats = response.data.items;
		});
	}
}
